import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as adminActions from '../actions/adminActions';
import * as authActions from '../actions/authActions';
import * as sessionActions from '../actions/sessionActions';
import * as profileActions from '../actions/profileActions';
import * as policyActions from '../actions/policyActions';
import { adminSelector, sessionSelector } from '../selectors';
import { StaffVerificationSection, AdminSettingsSection, ChatSettingsSection, UserAccountSection, SystemToggles } from './sections/admin';
import { Button, Form, Segment, Header } from 'semantic-ui-react';
import Section from '../components/Section';
import { push } from 'connected-react-router';
import { CSVLink } from 'react-csv';
import moment from 'moment';
import papa from 'papaparse';
import { saveAs } from 'file-saver';
import DatePicker from '../components/DatePicker';
import AdvertisementsSection from './sections/admin/AdvertisementsSection';

class AdminPage extends Component {
	constructor(props) {
		super(props);

		this.state = {
			bulkUpdateEDeliveryLoading: false,
			getEDeliveryDiscrepanciesLoading: false,
			activeUsersLoading: false,
			latestLogLoading: false,
			bulkUpdateReportData: [],
			activeOn: null,
			logs: [],
		};

		this.onBulkUpdateEDeliveryNotifications = this.onBulkUpdateEDeliveryNotifications.bind(this);
		this.onGetEDeliveryDiscrepancies = this.onGetEDeliveryDiscrepancies.bind(this);
		this.onGetActiveUsers = this.onGetActiveUsers.bind(this);
		this.onGetLog = this.onGetLog.bind(this);
		this.csvLink = React.createRef();
	}

	async componentDidMount() {
		const { actions } = this.props;
		await actions.getProfile();

		var result = await actions.getAllLogFiles();

		this.setState({ logs: result.response });
	}

	async onBulkUpdateEDeliveryNotifications(e) {
		e.preventDefault();

		const promptResponse = window.prompt('This action will synchronize eDelivery settings in Diamond with those in Member Portal.  For testing purposes, please enter a number of USERS to synchronize.  Otherwise, enter "ALL" to update ALL the policies.  This may take several minutes.', '50');

		if (promptResponse) {
			try {
				this.csvLink.current.link.hidden = true;
				this.setState({ bulkUpdateEDeliveryLoading: true });
				const { actions } = this.props;
				const result = await actions.adminBulkUpdateEDeliveryNotifications(promptResponse);

				this.setState({ bulkUpdateReportData: result.response }, () => {
					setTimeout(() => {
						const { bulkUpdateReportData } = this.state;
						if (bulkUpdateReportData.length > 0) {
							const currentDateTime = moment().format('YYYYMMDD_HHmmssSSS');
							const filename = `BulkUpdateReport_${currentDateTime}.csv`;

							window.alert(`The updates have been queued.  A report (${filename}) of these updates will be downloaded.`);

							this.csvLink.current.link.download = filename;

							this.csvLink.current.link.click();
							this.csvLink.current.link.hidden = false;
						} else {
							window.alert('No updates were returned.  Please contact support for more information.');
						}
						this.setState({ bulkUpdateEDeliveryLoading: false });
					});
				});
			} catch (error) {
				console.log(error);
				this.setState({ bulkUpdateEDeliveryLoading: false });
				window.alert(`FAILURE: ${error.message}`);
			}
		}
	}

	async onGetLog(log) {
		const { session } = this.props;

		try {
			fetch(`/api/admin/logfiles/download?name=${log}`, {
				method: 'GET',
				headers: new Headers({
					Authorization: 'Bearer ' + session.token,
				}),
			})
				.then((response) => response.blob())
				.then((blob) => {
					var url = window.URL.createObjectURL(blob);
					var a = document.createElement('a');
					a.href = url;
					a.download = log;
					document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
					a.click();
					a.remove(); //afterwards we remove the element again
				});
		} catch (e) {}
	}

	async onGetActiveUsers(e) {
		const { actions } = this.props;
		const { activeOn } = this.state;

		e.preventDefault();

		try {
			this.setState({ activeUsersLoading: true });

			var result = await actions.getActiveUsers(activeOn);
			const users = result.response;
			const columns = [];
			var maxPolicies = 0;
			users.forEach((user, i) => {
				maxPolicies = Math.max(user.policies.length, maxPolicies);
				if (i === 0) {
					Object.keys(user).forEach((column) => {
						if (column !== 'policies') {
							columns.push(column);
						}
					});
				}
			});

			for (var i = 0; i < maxPolicies; i++) {
				columns.push(`policyNumber${i + 1}`, `policyNumber${i + 1}Status`);
			}

			const newUsers = users.map((user, i) => {
				let newUser = { ...user };
				delete newUser.policies;
				user.policies.forEach((policy, i) => {
					newUser[`policyNumber${i + 1}`] = policy.policyNumber;
					newUser[`policyNumber${i + 1}Status`] = policy.status;
				});
				return newUser;
			});

			if (newUsers.length > 0) {
				var csv = papa.unparse({
					fields: columns,
					data: newUsers,
				});

				var csvBlob = new Blob([csv], { type: 'text/csv' });
				saveAs(csvBlob, 'activeUsers.csv');
			} else {
				alert('No active users');
			}

			this.setState({ activeUsersLoading: false });
		} catch (error) {
			this.setState({ activeUsersLoading: false });
			console.log(error);
		}
	}

	async onGetEDeliveryDiscrepancies(e) {
		e.preventDefault();
		try {
			this.setState({ getEDeliveryDiscrepanciesLoading: true });
			const { actions } = this.props;
			await actions.getEDeliveryDiscrepancies();
			this.setState({ getEDeliveryDiscrepanciesLoading: false });
		} catch (error) {
			this.setState({ getEDeliveryDiscrepanciesLoading: false });
			console.log(error);
		}
	}

	render() {
		const { admin, actions } = this.props;
		const { bulkUpdateEDeliveryLoading, getEDeliveryDiscrepanciesLoading, activeUsersLoading, bulkUpdateReportData, activeOn, logs } = this.state;
		return (
			<div>
				<AdminSettingsSection actions={actions} admin={admin} mobileShow />
				<UserAccountSection actions={actions} admin={admin} mobileShow />
				<StaffVerificationSection actions={actions} admin={admin} mobileShow />
				<ChatSettingsSection actions={actions} admin={admin} mobileShow />
				<AdvertisementsSection actions={actions} admin={admin} />
				<SystemToggles actions={actions} admin={admin} mobileShow />
				<Section name='onetime' title='Admin OneTime Use' color='red'>
					<div hidden>
						<Button disabled negative content='Compare Member Portal and Diamond eDelivery Settings' loading={getEDeliveryDiscrepanciesLoading} onClick={this.onGetEDeliveryDiscrepancies} />
					</div>
					<div>
						<Button negative content='Bulk Update Diamond eDelivery Settings' loading={bulkUpdateEDeliveryLoading} onClick={this.onBulkUpdateEDeliveryNotifications} />
						<CSVLink data={bulkUpdateReportData} filename='data.csv' hidden ref={this.csvLink} target='_blank'>
							{' '}
							Download Report Again
						</CSVLink>
					</div>
				</Section>
				<Section title='Data' color='red'>
					<Segment>
						<Header>Active Users</Header>
						<Form>
							<Form.Input control={DatePicker} label='Active On' onChange={(_, { value }) => this.setState({ activeOn: value })} selected={activeOn} type="date" />
							<Button content='Get Active Users' loading={activeUsersLoading} onClick={this.onGetActiveUsers} disabled={activeUsersLoading} />
						</Form>
					</Segment>
					{/* <Segment>
						<Header>Logs</Header>
						{logs.map((log, i) => (
							<Button key={i} onClick={() => this.onGetLog(log.name)}>
								{log.name}
							</Button>
						))}
					</Segment> */}
				</Section>
			</div>
		);
	}
}

AdminPage.propTypes = {
	actions: PropTypes.object.isRequired,
	admin: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
	return {
		admin: adminSelector(state),
		session: sessionSelector(state),
	};
};

const mapDispatchToProps = (dispatch) => ({
	actions: {
		...bindActionCreators({ push }, dispatch),
		...bindActionCreators(authActions, dispatch),
		...bindActionCreators(profileActions, dispatch),
		...bindActionCreators(policyActions, dispatch),
		...bindActionCreators(sessionActions, dispatch),
		...bindActionCreators(adminActions, dispatch),
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminPage);
